import api from '../../../services/api';
import buildQuery from 'odata-query'

export const FUNEL_URL = '/funil'

// Pega todas as LPP
export function getAllFunnels() {
  return api.get(FUNEL_URL)
}

export function fetchDataTable(idFactory) {
  return api.get(`${FUNEL_URL}/odata/` + buildQuery({
    // filter: 'standard/structure/factoryId+eq+' + idFactory,
    select: ['*'],
    expand:{
      structure: {
        select: ['name']
      },
      GTMUser:{
        select:['name']
      },
      GTAUser:{
        select:['name']
      },
    }

  }))
}

// Retorna os dados por filtro
export function getByFilters(queryParams) {
  return api.get(`${FUNEL_URL}/odata${queryParams}`)
}

// Retorna a view
export function fetchDataView(id) {
  return api.get(`${FUNEL_URL}/${id}`)
}

export function updateFunnel(funnel) {
  return api.put(`${FUNEL_URL}`, funnel);
}

export function updateActivities(dataActivities){
  return api.put(`${FUNEL_URL}activity`, dataActivities);
}

export function createFunnel(funnel) {
  return api.post(`${FUNEL_URL}`, funnel)
}
